export default function isArray(value: any) {
    return Array.isArray(value)
}